import React from "react";

const COLORS = {
  ACTIVE: "#10B981",
  BLOCKED: "#6B7280",
  INACTIVE: "#F59E0B",
};

export function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="px-3 py-1 rounded-full text-xs font-heading font-bold uppercase tracking-wider border-2 border-gray-800 text-white"
      style={{ background: COLORS[status] || "#6B7280" }}
    >
      {status}
    </span>
  );
}
